import { IconButton } from '@material-ui/core';
import { ArrowBackIosRounded } from '@mui/icons-material';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

import H2 from 'retired/H2';
import { dark, white } from 'utils/color-styles';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  arrowButton: {
    backgroundColor: white,
    border: ' 1px solid rgba(235, 238, 240, 1)',
    height: '100%',
    marginRight: 20,
  },
});

const PageHeaderRedesign: React.FC<{
  title?: string;
  onArrowClick: (event: React.MouseEvent<HTMLButtonElement>) => void | undefined;
  children: React.ReactNode;
}> = ({ title, onArrowClick, children }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <IconButton onClick={onArrowClick} className={classes.arrowButton}>
        <ArrowBackIosRounded style={{ color: dark }} />
      </IconButton>
      <H2 style={{ flex: 1 }}>{title}</H2>
      {children}
    </div>
  );
};

export default PageHeaderRedesign;
